// Template starter looks. Each sets the page background theme plus fonts and colours.
const ARTIST_LOOKS = [
  { key: "gallery-white", label: "Gallery White", note: "Bright, airy, thin serif type, like a modern gallery",
    page_theme: "light", heading_font: "playfair", accent_color: "#B08D57", heading_color: "#141414", swatch: ["#FAFAF7", "#141414", "#B08D57"] },
  { key: "studio-dark", label: "Studio Dark", note: "Deep charcoal so the artwork glows. Dramatic",
    page_theme: "charcoal", heading_font: "dmserif", accent_color: "#D9A441", heading_color: "#F5F2EC", swatch: ["#161514", "#F5F2EC", "#D9A441"] },
  { key: "warm-earth", label: "Warm Earth", note: "Beige taupe tones and softer type, with a handmade feel",
    page_theme: "taupe", heading_font: "fraunces", accent_color: "#9A5434", heading_color: "#2F241B", swatch: ["#D8CCBC", "#2F241B", "#9A5434"] },
];

const TEACHER_LOOKS = [
  { key: "classroom-bright", label: "Classroom Bright", note: "Fresh sage green, friendly and clear, with a deep green accent",
    page_theme: "sage", heading_font: "poppins", accent_color: "#3F7350", heading_color: "#1E2F22", swatch: ["#DCE5D5", "#1E2F22", "#3F7350"] },
  { key: "scholar", label: "Scholar", note: "Midnight navy with classic serif type and a gold accent",
    page_theme: "navy", heading_font: "playfair", accent_color: "#D4AF5A", heading_color: "#F3E7C4", swatch: ["#121A2B", "#F3E7C4", "#D4AF5A"] },
  { key: "studio-calm", label: "Studio Calm", note: "Soft linen and clean type with a gentle dusty blue",
    page_theme: "linen", heading_font: "satoshi", accent_color: "#4F7393", heading_color: "#26333F", swatch: ["#F1EADF", "#26333F", "#4F7393"] },
];

const STANDARD_LOOKS = [
  { key: "signal-classic", label: "Signal Classic", note: "Classic black with a teal glow, the original Signal look",
    page_theme: "dark", heading_font: "cabinet", accent_color: "#14A89A", heading_color: "#FFFFFF", swatch: ["#0A0A0A", "#FFFFFF", "#14A89A"] },
  { key: "royal-purple", label: "Royal Purple", note: "Rich, vivid purple with white lettering and a sunny gold spark",
    page_theme: "purple", heading_font: "space", accent_color: "#FFC857", heading_color: "#FFFFFF", swatch: ["#3B1670", "#FFFFFF", "#FFC857"] },
  { key: "bright-teal", label: "Bright Teal", note: "Bright ocean teal with white lettering and a warm coral pop",
    page_theme: "teal", heading_font: "poppins", accent_color: "#FF8A65", heading_color: "#FFFFFF", swatch: ["#0E8F89", "#FFFFFF", "#FF8A65"] },
];

export const TEMPLATE_LOOKS = { artist: ARTIST_LOOKS, teacher: TEACHER_LOOKS, standard: STANDARD_LOOKS };

export const TEMPLATE_EXAMPLE_TEXT = {
  artist: "Add 2 empty example collections, Featured Works (grid) and Studies (masonry). Rename or delete them anytime.",
  teacher: "Add 2 sample courses, Start Here: Sample Course (a step by step Path) and Sample Library (open in any order), each with 3 short sample lessons. Edit or delete them anytime.",
};

export const TEMPLATE_DETAILS = {
  artist: {
    best: "Painters, illustrators, photographers, makers and anyone selling or showcasing visual work.",
    gets: ["Gallery layouts (grid and masonry) with full screen, zoomable viewing", "Artwork details: medium, size, year, price, and a sold mark",
      "Watermarks and a public portfolio with share links for each piece", "Story extras: voice notes, studio videos and process photos", "Collectors can ask about a piece in a private message"],
    skip: "Skip it if you mainly teach step by step lessons or courses.",
  },
  teacher: {
    best: "Coaches, teachers, guides and anyone running courses or lesson series.",
    gets: ["Courses in Path (step by step) or Library (any order) layouts", "Optional progress tracking with Continue where you left off",
      "Insights: counts of who started, finished and where students tend to stop", "Private notes students write on each lesson, plus a resources shelf for downloads",
      "Drip release and optional completion certificates"],
    skip: "Skip it if you share mostly artwork, or one off posts and videos rather than courses.",
  },
  standard: {
    best: "Anyone who wants a clean, simple Beacon: musicians, writers, podcasters, community hosts and mixed content.",
    gets: ["Simple sections for videos, audio, text, images, links and live sessions", "No extra setup, start adding content right away",
      "Three bold looks to choose from"],
    skip: "Choose Artist or Teacher instead if you want gallery tools or course features.",
  },
};

export const STANDARD_LOOK = { page_theme: "dark", heading_font: "cabinet", accent_color: "#14A89A", heading_color: "#FFFFFF" };

export const TEMPLATES = [
  { key: "artist", label: "Artist", note: "Collections, gallery layouts and artwork details" },
  { key: "teacher", label: "Teacher", note: "Courses, lessons and student progress" },
  { key: "standard", label: "Freeform", note: "A blank canvas for any kind of work, shaped your way" },
];

export const themeClass = (t) => (t && t !== "dark" ? `bt-${t}` : "");

export const lookFields = (l) => ({
  page_theme: l.page_theme, heading_font: l.heading_font, accent_color: l.accent_color, heading_color: l.heading_color,
  tagline_font: "", tagline_color: "", section_font: "", section_color: "",
});
